import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ConfigurationComponent} from './configuration.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {LoginModule} from '../login/login.module';
import {LayoutModule} from '../layout/layout.module';
import {routing} from './configuration.routing';
import {ConfigComponent} from './config/config.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {AboutUsComponent} from './about-us/about-us.component';
import {SharedTranslationModule} from '../shared/change-language/shared-translation.module';
import {ExcelService} from '../exportexcel/excel.service';
import {Ng4LoadingSpinnerModule} from 'ng4-loading-spinner';
// import { InterfaceConfigComponent } from './interface-config/interface-config.component';


@NgModule({
    imports: [
        CommonModule, LoginModule, routing, LayoutModule, BrowserAnimationsModule, ReactiveFormsModule, Ng4LoadingSpinnerModule,
        FormsModule, SharedTranslationModule
    ],
    declarations: [ConfigurationComponent, ConfigComponent, AboutUsComponent,],
    providers: [ExcelService]
})
export class ConfigurationModule {
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/configuration/configuration.module.ts